/**
 * ============================================================
 * touni-mystery.js — Logique "Maillot Mystère Offert"
 * touni.ma — Shopify
 * ============================================================
 * INSTALLATION — juste avant </body> dans theme.liquid :
 *
 *   {%- render 'touni-mystery-banner' -%}
 *   <script src="{{ 'touni-mystery.js' | asset_url }}" defer></script>
 *
 * ============================================================
 */
(function () {
  'use strict';

  /* ── Désactiver complètement en mode admin (Theme Editor) ── */
  if (window.Shopify && window.Shopify.designMode) { return; }

  /* ── Configuration ──────────────────────────────────────── */
  var GIFT_HANDLE         = '🎁-maillot-mystere-offert-🎁'; // handle exact Shopify
  var MIN_QTY             = 3;        // articles normaux minimum
  var MIN_TOTAL           = 98700;    // en centimes = 987 MAD (3 x 329)
  var GIFT_PROP_KEY       = '_gift';
  var GIFT_PROP_VALUE     = 'mystere';
  /* Produits exclus des conditions (ne comptent ni dans les 3 articles ni dans le montant) */
  var FLOCAGE_VARIANT_ID  = 48343237066971;   // Flocage Personnalisé PRO - Nom + Numéro
  var FLOCAGE_PRODUCT_ID  = 9182567104731;
  var CHECK_INTERVAL_MS   = 3000;     // vérification toutes les 3s
  var POST_MUTATION_DELAY = 500;      // délai après mutation panier

  /* ── État interne ───────────────────────────────────────── */
  var giftVariantId    = null;
  var isProcessing     = false;
  var _cachedCart      = null;  // dernier état connu du panier
  var _selfDispatching = false; // flag anti-boucle : on ignore nos propres events

  /* ── Référence fetch original (utilisé par nos propres appels) ── */
  var _fetch = window.fetch.bind(window);

  /* ── Helper : identifier une ligne cadeau ───────────────── */
  function isGiftLine(item) {
    return (
      item.properties &&
      item.properties[GIFT_PROP_KEY] === GIFT_PROP_VALUE
    );
  }

  /* ── Helper : ligne exclue des conditions (flocage / personnalisation) ── */
  function isExcludedItem(item) {
    return (
      String(item.variant_id) === String(FLOCAGE_VARIANT_ID) ||
      String(item.product_id) === String(FLOCAGE_PRODUCT_ID)
    );
  }

  /* ── Helper : article QUALIFIANT pour le mystère ────────────
     SEULS les maillots de foot, kits et ensembles (survêtements) comptent.
     Les accessoires (casquettes, serviettes, ballons, shorts seuls, sacs,
     chaussettes, sandales…) NE comptent PAS — impossible de compléter les
     3 articles avec des accessoires. Basé sur le TYPE de produit (liste
     blanche), avec un filet sur le titre. « maillot de bain » = accessoire. */
  function isQualifyingItem(item) {
    var t  = String(item.product_type || '').toLowerCase();
    var ti = String(item.product_title || item.title || '').toLowerCase();
    if (ti.indexOf('bain') !== -1) return false;         // maillot/short de bain = accessoire
    if (t === 'maillot' || t === 'kit') return true;     // maillots + kits (Terrace Icons = type Maillot)
    if (t.indexOf('ensemble') !== -1) return true;       // ensembles + ensembles survêtement
    if (t.indexOf('surv') !== -1) return true;           // survêtements
    if (ti.indexOf('maillot') !== -1) return true;       // filet : titre « Maillot … » (ex. pré-match)
    return false;
  }

  /* ── Intercepteur fetch ─────────────────────────────────── */
  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var req  = args[0];
    var url  = typeof req === 'string' ? req
               : (req && typeof req.url === 'string') ? req.url : '';

    /* ── BLOQUER : changement de quantité sur la ligne cadeau ── */
    if (/\/cart\/change\.js(\?|$)/.test(url) && _cachedCart) {
      try {
        var body = args[1] && args[1].body;
        if (body) {
          var payload = typeof body === 'string' ? JSON.parse(body) : body;
          var lineIdx = payload.line; // 1-based
          if (lineIdx !== undefined && _cachedCart.items) {
            var targetItem = _cachedCart.items[lineIdx - 1];
            if (targetItem && isGiftLine(targetItem)) {
              /* Bloquer toute modification de quantité par l'utilisateur.
               * Nos propres appels (normalizeGiftQuantity, removeGift)
               * passent par _fetch et ne sont pas bloqués. */
              console.log('[Touni Mystery] Blocked external change on gift line (line ' + lineIdx + ')');
              /* Retourner le panier actuel sans modification */
              return Promise.resolve(
                new Response(JSON.stringify(_cachedCart), {
                  status:  200,
                  headers: { 'Content-Type': 'application/json' }
                })
              );
            }
          }
        }
      } catch (e) { /* si le parse échoue, laisser passer */ }
    }

    /* ── BLOQUER : ajout direct du produit cadeau via cart/add ── */
    if (/\/cart\/add\.js(\?|$)/.test(url) && giftVariantId) {
      try {
        var addBody = args[1] && args[1].body;
        if (addBody) {
          var addPayload = typeof addBody === 'string' ? JSON.parse(addBody) : addBody;
          var addedId    = addPayload.id || (addPayload.items && addPayload.items[0] && addPayload.items[0].id);
          /* Bloquer si c'est le produit cadeau sans la propriété _gift
           * (ajout manuel par le client depuis la fiche produit ou autre) */
          if (String(addedId) === String(giftVariantId)) {
            var hasGiftProp = addPayload.properties && addPayload.properties[GIFT_PROP_KEY] === GIFT_PROP_VALUE;
            if (!hasGiftProp) {
              console.log('[Touni Mystery] Blocked manual add of gift variant');
              return Promise.resolve(
                new Response(JSON.stringify({ status: 422, description: 'Not available' }), {
                  status:  422,
                  headers: { 'Content-Type': 'application/json' }
                })
              );
            }
          }
        }
      } catch (e) { /* laisser passer en cas d'erreur */ }
    }

    /* Laisser passer toutes les autres requêtes */
    var promise = _fetch.apply(window, args);

    /* Re-vérifier le panier après toute mutation panier */
    if (/\/cart\/(add|change|update)\.js(\?|$)/.test(url)) {
      promise.then(function () {
        setTimeout(checkCart, POST_MUTATION_DELAY);
      }).catch(function () {});
    }

    return promise;
  };

  /* ── Récupération variantId cadeau (mis en cache) ───────── */
  function fetchGiftVariantId(callback) {
    if (giftVariantId) { callback(giftVariantId); return; }
    _fetch('/products/' + encodeURIComponent(GIFT_HANDLE) + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (data && data.variants && data.variants.length > 0) {
          giftVariantId = data.variants[0].id;
          callback(giftVariantId);
        } else {
          console.warn('[Touni Mystery] Produit cadeau introuvable : ' + GIFT_HANDLE);
        }
      })
      .catch(function (err) {
        console.warn('[Touni Mystery] Erreur récupération produit cadeau :', err);
      });
  }

  /* ── Notifier l'UI ──────────────────────────────────────── */
  function updateUI(itemCount, totalCentimes, conditionMet) {
    if (typeof window.touniUpdateGiftUI === 'function') {
      window.touniUpdateGiftUI(itemCount, totalCentimes, conditionMet);
    }
  }

  /* ── Notifier le thème Shopify ──────────────────────────── */
  function notifyTheme() {
    /* Flag anti-boucle : nos propres événements ne doivent pas
     * re-déclencher checkCart via nos listeners (dispatchEvent est synchrone) */
    _selfDispatching = true;
    document.dispatchEvent(new CustomEvent('cart:updated',        { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh',        { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:cart:updated',  { bubbles: true }));
    _selfDispatching = false;
  }

  /* ── Ajouter le cadeau ──────────────────────────────────── */
  function addGift(variantId) {
    /* isProcessing est déjà true avant cet appel */
    _fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: { _gift: GIFT_PROP_VALUE } })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function () {
        console.log('[Touni Mystery] Cadeau ajouté.');
        isProcessing = false;
        notifyTheme();
      })
      .catch(function (err) {
        console.warn('[Touni Mystery] Erreur ajout cadeau :', err);
        isProcessing = false;
      });
  }

  /* ── Normaliser la quantité cadeau à 1 ──────────────────── */
  function normalizeGiftQuantity(lineIndex) {
    /* isProcessing est déjà true avant cet appel */
    _fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function () {
        console.log('[Touni Mystery] Quantité cadeau ramenée à 1.');
        isProcessing = false;
        notifyTheme();
      })
      .catch(function (err) {
        console.warn('[Touni Mystery] Erreur normalisation cadeau :', err);
        isProcessing = false;
      });
  }

  /* ── Supprimer le cadeau ────────────────────────────────── */
  function removeGift(lineIndex) {
    /* isProcessing est déjà true avant cet appel */
    _fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function () {
        console.log('[Touni Mystery] Cadeau retiré.');
        isProcessing = false;
        notifyTheme();
      })
      .catch(function (err) {
        console.warn('[Touni Mystery] Erreur suppression cadeau :', err);
        isProcessing = false;
      });
  }

  /* ── Traitement du panier ───────────────────────────────── */
  function processCart(cart) {
    _cachedCart = cart; // mettre à jour le cache systématiquement

    var items       = cart.items || [];
    var normalItems = [];
    var giftLines   = [];

    for (var i = 0; i < items.length; i++) {
      if (isGiftLine(items[i])) {
        giftLines.push({ item: items[i], lineIndex: i + 1 });
      } else {
        normalItems.push(items[i]);
      }
    }

    var totalQty   = 0;
    var totalPrice = 0;
    for (var j = 0; j < normalItems.length; j++) {
      /* Seuls les maillots / kits / ensembles qualifient (qté ET montant).
         Les accessoires ne comptent pas → pas de mystère avec des casquettes. */
      if (isQualifyingItem(normalItems[j])) {
        totalPrice += normalItems[j].line_price;
        totalQty   += normalItems[j].quantity;
      }
    }

    /* Condition = 3 maillots/kits/ensembles. Le montant n'est plus une condition
       (3 maillots ≥ 987 MAD de toute façon) → on retire le seuil montant. */
    var conditionMet = (totalQty >= MIN_QTY);
    var giftPresent  = giftLines.length > 0;

    updateUI(totalQty, totalPrice, conditionMet);

    if (isProcessing) return;

    if (conditionMet && !giftPresent) {
      /* FIX RACE CONDITION : verrouiller avant tout appel async */
      isProcessing = true;
      fetchGiftVariantId(function (variantId) {
        _fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (freshCart) {
            _cachedCart = freshCart;
            var alreadyHasGift = (freshCart.items || []).some(isGiftLine);
            if (!alreadyHasGift) {
              addGift(variantId);
            } else {
              isProcessing = false;
            }
          })
          .catch(function () { isProcessing = false; });
      });

    } else if (conditionMet && giftPresent) {
      if (giftLines.length > 1) {
        /* Plusieurs lignes cadeau : supprimer la dernière */
        isProcessing = true;
        removeGift(giftLines[giftLines.length - 1].lineIndex);
      } else if (giftLines[0].item.quantity > 1) {
        /* Quantité > 1 : normaliser à 1 (filet de sécurité si le blocage fetch échoue) */
        isProcessing = true;
        normalizeGiftQuantity(giftLines[0].lineIndex);
      }

    } else if (!conditionMet && giftPresent) {
      isProcessing = true;
      removeGift(giftLines[0].lineIndex);
    }
  }

  /* ── Vérification principale du panier ──────────────────── */
  function checkCart() {
    _fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(processCart)
      .catch(function (err) {
        console.warn('[Touni Mystery] Impossible de lire le panier :', err);
      });
  }

  /* ── Écouter les événements panier du thème ─────────────── */
  /* Note : on ignore nos propres événements (_selfDispatching) pour éviter
   * la boucle de feedback : notifyTheme() → cart:updated → checkCart → ... */
  var cartEvents = [
    'cart:updated', 'cart:refresh', 'theme:cart:updated',
    'ajaxCart:updated', 'cartUpdate'
  ];
  cartEvents.forEach(function (evt) {
    document.addEventListener(evt, function () {
      if (_selfDispatching) return;
      setTimeout(checkCart, POST_MUTATION_DELAY);
    });
  });

  /* ── Démarrage ──────────────────────────────────────────── */
  /* 27/10 : plus de relecture du panier toutes les 3 s (40 requêtes/min/onglet -> blocage 429 Shopify sur les IP partagées).
     Relecture seulement quand le client revient sur l'onglet (au plus 1 fois toutes les 20 s) + après chaque événement panier (ci-dessus). */
  var _lastVis = 0;
  function checkOnReturn() { if (document.visibilityState !== 'visible') return; var t = Date.now(); if (t - _lastVis < 20000) return; _lastVis = t; checkCart(); }
  document.addEventListener('visibilitychange', checkOnReturn);
  window.addEventListener('pageshow', checkOnReturn);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(checkCart, 300);
    });
  } else {
    setTimeout(checkCart, 300);
  }

}());
